import React, { useMemo, useCallback } from 'react'
import {
  Box, Text, ImageLoader, LazyLoad,
} from '@usap/uicomponents'
import { ImageText } from './StyledCSS'
import BoxHover from './style/ImageWithText.css'

export default function ImageWithText({
  id,
  isDesktop,
  isBot,
  elevation,
  boxWidth,
  boxBgColor = 'white',
  boxGap = isDesktop ? '8' : '4',
  boxMargin = isDesktop ? '8px' : '4px',
  boxPad = isDesktop ? '8px' : '0px',
  cloudinaryParams,
  imageHeight,
  imageWidth,
  imageSrc,
  imageText,
  alt = imageText,
  imagePad = isDesktop ? 'medium' : { horizontal: '8px' },
  imageMargin = { bottom: '8px' },
  isNew,
  Link,
  to,
  skip = false,
  onClick = () => { },
  handleClick = () => { },
  noLazy = false,
}) {
  const marginWidth = 2 * boxGap
  const newBadgePosition = isDesktop ? '7%' : '5%'
  const elevations = typeof elevation === 'undefined' ? 'none' : elevation
  const checkDesktop = !isDesktop ? 'small' : 'auto'
  const cssWidth = `calc(${boxWidth} - ${marginWidth}px)`

  const clickHandler = useCallback(() => {
    handleClick(imageText)
    onClick()
  }, [imageText])

  return useMemo(
    () => (
      <BoxHover
        id={id}
        margin={boxMargin}
        elevation={elevations}
        style={{ width: cssWidth }}
        background={boxBgColor}
      >
        {isNew && (
          <Text
            size="xsmall"
            color="#0E3080"
            style={{
              fontWeight: 700,
              height: 0,
              top: '10px',
              position: 'relative',
              left: newBadgePosition,
            }}
          >
            NEW
          </Text>
        )}
        <Link
          to={to}
          skip={skip}
          onClick={clickHandler}
          style={{ flexGrow: '1' }}
        >
          <Box pad={boxPad}>
            <Box
              alignSelf="center"
              justify="center"
              pad={imagePad}
              margin={imageMargin}
              height={imageHeight}
              width={imageWidth}
            >
              <ImageLoader
                layout="fixed"
                height="100%"
                width="100%"
                fit="contain"
                src={imageSrc}
                alt={alt}
                cloudinaryParams={cloudinaryParams}
                isBot={isBot}
                noLazyLoad={noLazy}
              />
            </Box>
            <Box
              pad={{
                horizontal: 'small',
                vertical: checkDesktop,
              }}
            >
              <ImageText
                color="dark-2"
                weight={500}
                size="14px"
                textAlign="center"
              >
                {imageText}
              </ImageText>
            </Box>
          </Box>
        </Link>
      </BoxHover>
    ),
    [cloudinaryParams],
  )
}
